import index from './index.vue';

export default [
  {
    path: '/ai-dashboard-builder',
    name: 'AI Dashboard Builder',
    component: index,
    meta: {
      title: 'AI Dashboard Builder',
    },
  },
];
